// extracted by mini-css-extract-plugin
export default {"toast":"index_toast__5jgU5"};